export default {
  routes: [
    {
      name: 'anthropometries',
      path: '/directory/anthropometry',
      component: () => import('./views/TheAnthropometries.vue'),

    },

    {
      name: 'anthropometry',
      path: '/directory/anthropometry/:uuid',
      component: () => import('./views/TheAnthropometry.vue'),
    },
  ]
}
